<template>
  <div class="overtimeRules">
    <Header headerTitle="超时计费标准"></Header>
    <section>
      <b-row>
        <b-col cols="12">超时收费标准</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">上海虹桥T1、T2、火车站</b-col>
        <b-col cols="8">5元/0.5小时，10元/小时 (封顶价100元/天)</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">北京航空机场T1、B2</b-col>
        <b-col cols="8">5元/0.5小时，10元/小时 (封顶价100元/天)</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">备注</b-col>
        <b-col cols="8">不足0.5小时，以0.5小时计算;大于0.5小时，不足1小时，以1小时计算</b-col>
      </b-row>
    </section>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { timeOutPricingDetails } from "@/api/public.js";
export default {
  name: "OvertimeRules",
  data() {
    return {
      overTimeList: {},
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //加载数据
    loadOverTimeList: function() {
      timeOutPricingDetails({}).then(
        response => {
          if (response.data.status == 200) {
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }
  },
  mounted() {
    this.loadOverTimeList();
  }
};
</script>
<style>
.overtimeRules section {
  width: 100%;
  padding: 10px;
}

.overtimeRules section .row {
  padding: 0 15px;
}
.overtimeRules section .row .col-12 {
  background-color: #f1f1f1;
  justify-content: center;
  margin-bottom: 3px;
  line-height: 70px;
}
.overtimeRules section .row .col-4 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  height: 100px;
  margin-bottom: 3px;
  font-size: 0.98rem;
  padding: 0;
  text-align: center;
}
.overtimeRules section .row .col-8{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  height: 100px;
  margin-bottom: 3px;
  text-align: left;
  margin-left: 5px;
  max-width: 65%;
}
</style>


